import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@store/store';

const selectServerTime = (state: RootState) => state.serverTime.time;

export const selectServerTimeDate = createSelector([selectServerTime], (time) => (time ? new Date(time) : null));
